import AbstractScreenMediator from "../../../../../shared/src/ranj/app/ui/AbstractScreenMediator";
import Anchor from "../../../../lib/html5-software-library/src/ranj/layout/Anchor";
import TextFitter from "../../../../lib/html5-software-library/src/ranj/layout/TextFitter";
import { getURLParameter } from "../../../../lib/html5-software-library/src/ranj/util/URLUtil";
import Config from "../../app/config/Config";
import ContextEvent from "../../app/core/ContextEvent";
import StartupEvent from "../../app/startup/StartupEvent";
import LanguageEvent from "../startup/events/LanguageEvent";

export default class BaseSplashScreenMediator extends AbstractScreenMediator {

    constructor(target, dispatcher, languagePack, layoutManager, startup, soundManager, config) {
        super(target, dispatcher, languagePack, layoutManager, soundManager);
        this.dispatcher = dispatcher;
        this._startup = startup;
        this._config = config;

        this._setProgress(0);

        this._handlePreloadCompleteBound = this._handlePreloadComplete.bind(this);
        this._handleLoadProgressBound = this._handleLoadProgress.bind(this);
        this._handleLanguageInitializedBound = this._handleLanguageInitialized.bind(this);
    }

    initialize() {
        super.initialize();

        this._instantHideTexts();
        this._dispatcher.addEventListener(LanguageEvent.INITIALIZED, this._handleLanguageInitializedBound);

        this._buttonStartGame = this.createButton(this._target.startButton, this._handleStartButtonClick.bind(this));
        this._buttonStartGame.setVisible(false);

        this._exposeStartButton();

        this._startup.addEventListener(StartupEvent.PROGRESS, this._handleLoadProgressBound);
        this._startup.addEventListener(StartupEvent.COMPLETE, this._handlePreloadCompleteBound);

        // this._showVersion();
        this._hideVersion();
        this._logVersion();

        this.anchorObject(this._target.startButton, Anchor.B);
        this.anchorObject(this._target.versionTextField, Anchor.B);
        this.anchorObject(this._target.loadingBar, Anchor.B);
        this.anchorObject(this._target.loadingTextField, Anchor.B);
        this.anchorObject(this._target.titleTextfield, Anchor.T);
        this.anchorObject(this._target.bodyTextfield, Anchor.T);
    }

    destroy() {
        super.destroy();

        this._dispatcher.removeEventListener(LanguageEvent.INITIALIZED, this._handleLanguageInitializedBound);

        this._startup.removeEventListener(StartupEvent.PROGRESS, this._handleLoadProgressBound);
        this._startup.removeEventListener(StartupEvent.COMPLETE, this._handlePreloadCompleteBound);
    }

    _showVersion() {
        if (this._target.versionTextField) {
            const version = this._config.getValue(Config.VERSION);
            const commitHash = this._config.getValue(Config.COMMIT_HASH);

            const str = `${version} (${commitHash})`;
            this._target.versionTextField.text = str;
        }
    }

    _hideVersion() {
        if (this._target.versionTextField) {
            this._target.versionTextField.visible = false;
        }
    }

    _logVersion() {
        const version = this._config.getValue(Config.VERSION);
        const commitHash = this._config.getValue(Config.COMMIT_HASH);

        console.log(`Version: ${version} (${commitHash})`);
    }

    _setProgress(progress) {
        const t = this._target.loadingBar.duration;
        const percentage = Math.round(t * progress);
        this._target.loadingBar.gotoAndStop(Math.min(t - 1, percentage));
    }

    _handleLoadProgress({ data }) {
        this._setProgress(data.progress);
    }

    _handlePreloadComplete() {
        this._startup.removeEventListener(StartupEvent.PROGRESS, this._handleLoadProgressBound);
        this._startup.removeEventListener(StartupEvent.COMPLETE, this._handlePreloadCompleteBound);
        this._target.loadingBar.visible = this._target.loadingTextField.visible = false;
        this._buttonStartGame.setVisible(true);

        if (getURLParameter("autostart") == "1") {
            setTimeout(function () { this._handleStartButtonClick(); }.bind(this), 15);
        }
    }

    _handleStartButtonClick() {
        // this.playSound(SoundType.SOUND_CLICK);
        // this._soundManager.initializeStreamChannels("./assets/sounds/silent.mp3");
        this._buttonStartGame.setEnabled(false);
        this._start();
    }

    _handleLanguageInitialized() {
        this._showTexts();
    }

    _start() {
        var contextEvent = new ContextEvent(ContextEvent.START_GAME);
        this.dispatcher.dispatch(contextEvent.type, { data: contextEvent });
    }

    // Used for integration testing by Equalture
    _exposeStartButton() {
        window.actions = window.actions || {};
        window.actions.clickStartButton = () => {
            return new Promise((resolve, reject) => {
                const startButtonSkin = this._target.startButton;
                const handleStartButtonClick = this._handleStartButtonClick.bind(this);

                (function waitForStartButtonToBeVisible() {
                    if (startButtonSkin.visible) {
                        handleStartButtonClick();
                        return resolve();
                    }
                    setTimeout(waitForStartButtonToBeVisible, 30);
                })();
            });
        }
    }

    _instantHideTexts() {
        this._target.titleTextfield.alpha = 0;
        this._target.bodyTextfield.alpha = 0;
        this._target.loadingTextField.alpha = 0;
    }

    _showTexts() {
        this._buttonStartGame.setLabel(this.getText("start.button"));

        const titleTextFitter = new TextFitter(this._target.titleTextfield, { fontStep: 1 });
        titleTextFitter.setText(this.getText("start.title"));
        this._target.bodyTextfield.text = this.getText("start.body");
        this._target.loadingTextField.text = this.getText("start.loading");

        createjs.Tween.get(this._target.titleTextfield)
            .to({ alpha: 1 }, 650, createjs.Ease.sineInOut);
        createjs.Tween.get(this._target.bodyTextfield)
            .to({ alpha: 1 }, 650, createjs.Ease.sineInOut);
        createjs.Tween.get(this._target.loadingTextField)
            .to({ alpha: 1 }, 650, createjs.Ease.sineInOut);
    }
}